<template>
  <es-loader
    v-if="loading"
    style="margin: 15rem"
  />
  <es-exception
    v-else-if="loadingError"
    style="padding: 15rem"
    margin="0rem"
    iconSize="3x"
    :exceptionMessage="errorMessage"
  />
  <div v-else class="document-container">
    <split-id-info-panel
      style="margin-bottom: 1rem"
      :cannotSplit="cannotSplit"
      :dataAccessErrorMessage="dataAccessErrorMessage"
      :dataAccessPermission="dataAccessPermission"
      :dataAccessPermissionNearMatch="dataAccessPermissionNearMatch"
      :differentPersonType="differentPersonType"
      :idToSplit="idToRetain"
      :diffPersonType="diffPersonType"
      :newId="newPerson ? newPerson.stateStudentId : null"
      :page="page"
      :personTypeMisMatched="personTypeMisMatched"
      :splitConfirmed="splitConfirmed"
      :splitReason="splitReason"
    />
    <div class="columns is-desktop">
      <div class="column">
        <shared-id-group-details
          v-if="showSharedIdGroupDetails"
          @flipSummary="storeNewIdToCreate"
          @showReviewSplitIdConfirmation="storeData"
          :allHistMatchingInfo="allHistMatchingInfo"
          :allHistTransactionInfo="allHistTransactionInfo"
          :cannotSplit="cannotSplit"
          :dataAccessErrorMessage="dataAccessErrorMessage"
          :dataAccessPermission="dataAccessPermission"
          :dataAccessPermissionNearMatch="dataAccessPermissionNearMatch"
          :originalPersonToSplit="personToSplit"
          :originalPersonToSplitHistInfo="personToSplitHistInfo"
          :originalPersonToSplitLocInfo="personToSplitLocInfo"
          :originalPersonToSplitLocHistInfo="personToSplitLocHistInfo"
          :originalPersonToSplitAliasIdInfo="personToSplitAliasIdInfo"
          :originalPersonToSplitMatchingInfo="personToSplitMatchingInfo"
          :originalPersonToSplitTransactionInfo="personToSplitTransactionInfo"
          :newPerson="newPerson"
          :newPersonHistInfo="newPersonHistInfo"
          :newPersonLocInfo="newPersonLocInfo"
          :newPersonLocHistInfo="newPersonLocHistInfo"
          :newPersonAliasIdInfo="newPersonAliasIdInfo"
          :newPersonMatchingInfo="newPersonMatchingInfo"
          :newPersonTransactionInfo="newPersonTransactionInfo"
          :personTypeMisMatched="personTypeMisMatched"
          :splitConfirmed="splitConfirmed"
        />
        <review-split-id-confirmation
          v-else
          @loadingError="setLoadingError"
          @viewSplitConfirmationPage="loadNewData"
          @showSplitIdDetails="cancelReviewData"
          :data="requestData"
        />
      </div>
      <div class="column is-3">
        <div v-if="showSharedIdGroupDetails">
          <split-id-summary
            style="margin-bottom: 1rem"
            :aliasIdsCount="aliasIdsCount"
            :newIdToCreate="newIdToCreate"
            :newId="newPerson ? newPerson.stateStudentId : null"
            :retainedId="idToRetain"
          />
          <quick-tips-shared-id-group-details/>
        </div>
        <quick-tips-review-split-id-confirmation v-else/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import QuickTipsReviewSplitIdConfirmation from '@/components/ID Manager Components/QuickTipsReviewSplitIdConfirmation.vue';
import QuickTipsSharedIdGroupDetails from '@/components/ID Manager Components/QuickTipsSharedIdGroupDetails.vue';
import ReviewSplitIdConfirmation from '@/components/ID Manager Components/ReviewSplitIdConfirmation.vue';
import SharedIdGroupDetails from '@/components/ID Manager Components/SharedIdGroupDetails.vue';
import SplitIdInfoPanel from '@/components/ID Manager Components/SplitIdInfoPanel.vue';
import SplitIdSummary from '@/components/ID Manager Components/SplitIdSummary.vue';
import NotificationManager from '@/mixins/NotificationManager';
import { mapGetters } from 'vuex';

export default {
  mixins: [
    NotificationManager,
  ],
  components: {
    EsException,
    EsLoader,
    QuickTipsReviewSplitIdConfirmation,
    QuickTipsSharedIdGroupDetails,
    ReviewSplitIdConfirmation,
    SharedIdGroupDetails,
    SplitIdInfoPanel,
    SplitIdSummary,
  },
  data() {
    return {
      allHistMatchingInfo: [],
      allHistTransactionInfo: [],
      cannotSplit: false,
      dataAccessErrorMessage: null,
      dataAccessPermission: false,
      dataAccessPermissionNearMatch: false,
      differentPersonType: false,
      diffPersonType: null,
      errorMessage: 'There was an issue. Please try again or contact your administrator.',
      idToRetain: null,
      loading: false,
      loadingError: false,
      newIdToCreate: null,
      newPerson: null,
      newPersonAliasIdInfo: null,
      newPersonHistInfo: null,
      newPersonLocInfo: null,
      newPersonLocHistInfo: [],
      newPersonMatchingInfo: {},
      newPersonTransactionInfo: null,
      page: 'Details',
      personToSplit: null,
      personToSplitAliasIdInfo: null,
      personToSplitHistInfo: null,
      personToSplitLocInfo: null,
      personToSplitLocHistInfo: [],
      personToSplitMatchingInfo: {},
      personToSplitTransactionInfo: null,
      personTypeMisMatched: false,
      requestData: null,
      showSharedIdGroupDetails: true,
      splitConfirmed: false,
      splitReason: null,
    };
  },
  created() {
    this.onLoad();
  },
  computed: {
    ...mapGetters([
      'userDistricts',
      'userPersonTypes',
      'userSchools',
    ]),
    districts() {
      return this.userDistricts.map(a => a.code);
    },
    personTypes() {
      return this.userPersonTypes.map(a => a.code);
    },
    schools() {
      return this.userSchools.map(a => a.code);
    },
    aliasIdsCount() {
      let temp = null;
      if (this.personToSplitAliasIdInfo !== null && this.personToSplitAliasIdInfo.length) {
        temp = this.personToSplitAliasIdInfo.length;
      }
      if (this.newPersonAliasIdInfo !== null && this.newPersonAliasIdInfo.length) {
        temp += this.personToSplitAliasIdInfo.length;
      }
      return temp;
    },
    setOfPersonPersonTypes() {
      if (this.personToSplit && this.personToSplit.personType) {
        const uniquePersonTypes = new Set();
        uniquePersonTypes.add(this.personToSplit.personType);
        this.personToSplitHistInfo.forEach((info) => {
          uniquePersonTypes.add(info.personType);
        });
        return [...uniquePersonTypes];
      }
      return [];
    },
    setOfPersonDistricts() {
      if (this.personToSplit && this.personToSplit.districtCode) {
        const uniqueDistricts = new Set();
        uniqueDistricts.add(this.personToSplit.districtCode);
        this.personToSplitHistInfo.forEach((info) => {
          uniqueDistricts.add(info.districtCode);
        });
        return [...uniqueDistricts];
      }
      return [];
    },
    setOfPersonSchools() {
      if (this.personToSplit && this.personToSplit.schoolCode) {
        const uniqueSchoolCodes = new Set();
        uniqueSchoolCodes.add(this.personToSplit.schoolCode);
        this.personToSplitHistInfo.forEach((info) => {
          uniqueSchoolCodes.add(info.schoolCode);
        });
        return [...uniqueSchoolCodes];
      }
      return [];
    },
  },
  methods: {
    async loadNewData(data) {
      this.splitConfirmed = data.splitConfirmed;
      this.splitReason = data.splitReason;
      this.loading = true;
      this.loadingError = false;
      try {
        const sort = [{
          field: 'lastUpdateDate',
          order: 'DESC',
        }];
        const params = new URLSearchParams();
        params.append('pageSize', 9999);
        params.append('sort', JSON.stringify(sort));
        const response = await axios.get(`idmanager/validate?id=${data.retainedId}`);
        if (response.status === 200) {
          this.personToSplit = response.data.student;
          /* eslint-disable */
          const temp = await axios.get(`person/${data.retainedId}/location`);
          if (temp.data) {
            temp.data.forEach(l => {
              if (this.personToSplit.lastTranSerialNumber === l.lastTranSerialNumber) {
                this.personToSplitLocInfo = l;
              } else {
                this.personToSplitLocHistInfo.push(l);
              }
            });
          }
          const temp2 = await axios.get(`person/${data.retainedId}/history`, { params });
          this.personToSplitHistInfo = temp2.data.data;
          const temp3 = await axios.get(`person/${data.retainedId}/locationhistory`);
          if (temp3.data) {
            temp3.data.forEach(lh => {
              this.personToSplitLocHistInfo.push(lh);
            });
          }
          const temp4 = await axios.get(`person/${data.retainedId}/aliasid`);
          let allTransIdsFromHistRecords = this.personToSplitHistInfo.map(a => a.lastTranSerialNumber);
          allTransIdsFromHistRecords.push(this.personToSplit.lastTranSerialNumber);
          let sortedAllLastTransIds = allTransIdsFromHistRecords.sort();
          let temp5 = temp4.data.data;
          let ids = temp5.map(a => a.tranSerialNumber);
          let aliasIdTransSerialNumber = ids.map(Number);
          let inValidIds = sortedAllLastTransIds.filter(item => aliasIdTransSerialNumber.includes(item));
          let validAliasIds = aliasIdTransSerialNumber.filter(item => !inValidIds.includes(item));
          this.personToSplitAliasIdInfo = temp5.filter(item => validAliasIds.includes(item.tranSerialNumber));
          const temp6 = await axios.get(`personid/transactions/details?pidSubmissionId=${this.personToSplit.lastTranSerialNumber}&getDetails=true`);
          if (temp6.data.data && temp6.data.data.length !== 0) {
            this.personToSplitMatchingInfo = temp6.data.data[0];
          }
          const temp7 = await axios.get(`/personid/transactions/${this.personToSplit.lastTranSerialNumber}/transbatch`);
          this.personToSplitTransactionInfo = temp7.data;
        }

        const response2 = await axios.get(`idmanager/validate?id=${data.newId}`);
        if (response2.status === 200) {
          this.newPerson = response2.data.student;
          /* eslint-disable */
          const temp = await axios.get(`person/${data.newId}/location`);
          if (temp.data) {
            temp.data.forEach(l => {
              if (this.newPerson.lastTranSerialNumber === l.lastTranSerialNumber) {
                this.newPersonLocInfo = l;
              } else {
                this.newPersonLocHistInfo.push(l);
              }
            });
          }
          const temp2 = await axios.get(`person/${data.newId}/history`, { params });
          this.newPersonHistInfo = temp2.data.data;
          const temp3 = await axios.get(`person/${data.newId}/locationhistory`);
          if (temp3.data) {
            temp3.data.forEach(lh => {
              this.newPersonLocHistInfo.push(lh);
            });
          }
          const temp4 = await axios.get(`person/${data.newId}/aliasid`);
          let allTransIdsFromHistRecords = this.newPersonHistInfo.map(a => a.lastTranSerialNumber);
          allTransIdsFromHistRecords.push(this.newPerson.lastTranSerialNumber);
          let sortedAllLastTransIds = allTransIdsFromHistRecords.sort();
          let temp5 = temp4.data.data;
          let ids = temp5.map(a => a.tranSerialNumber);
          let aliasIdTransSerialNumber = ids.map(Number);
          let inValidIds = sortedAllLastTransIds.filter(item => aliasIdTransSerialNumber.includes(item));
          let validAliasIds = aliasIdTransSerialNumber.filter(item => !inValidIds.includes(item));
          this.newPersonAliasIdInfo = temp5.filter(item => validAliasIds.includes(item.tranSerialNumber));
          const temp6 = await axios.get(`personid/transactions/details?pidSubmissionId=${this.newPerson.lastTranSerialNumber}&getDetails=true`);
          if (temp6.data.data && temp6.data.data.length !== 0) {
            this.newPersonMatchingInfo = temp6.data.data[0];
          }
          const temp7 = await axios.get(`/personid/transactions/${this.newPerson.lastTranSerialNumber}/transbatch`);
          this.newPersonTransactionInfo = temp7.data;
        }
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
        this.page = 'Confirm';
        this.toggleComponent();
      }
    },
    async onLoad() {
      this.loading = true;
      const sort = [{
        field: 'lastUpdateDate',
        order: 'DESC',
      }];
      const params = new URLSearchParams();
      params.append('pageSize', 9999);
      params.append('sort', JSON.stringify(sort));
      try {
        const response = await axios.get(`idmanager/validate?id=${this.$route.query.stateId}`);
        if (response.status === 200 && response.data.student) {
          this.personToSplit = response.data.student;
          this.idToRetain = this.personToSplit.stateStudentId;
          if (response.data.message !== null) {
            this.showError(response.data.message);
            this.dataAccessPermissionNearMatch = true;
            this.dataAccessErrorMessage = response.data.message;
          }
          const temp = await axios.get(`person/${this.$route.query.stateId}/location`);
          if (temp.data) {
            temp.data.forEach(l => {
              if (this.personToSplit.lastTranSerialNumber === l.lastTranSerialNumber) {
                this.personToSplitLocInfo = l;
              } else {
                this.personToSplitLocHistInfo.push(l);
              }
            });
          }
          const temp2 = await axios.get(`person/${this.$route.query.stateId}/history`, { params });
          this.personToSplitHistInfo = temp2.data.data;
          const temp3 = await axios.get(`person/${this.$route.query.stateId}/locationhistory`);
          if (temp2.data) {
            temp3.data.forEach(lh => {
              this.personToSplitLocHistInfo.push(lh);
          });
          }
          const temp4 = await axios.get(`person/${this.$route.query.stateId}/aliasid`);
          let allTransIdsFromHistRecords = this.personToSplitHistInfo.map(a => a.lastTranSerialNumber);
          allTransIdsFromHistRecords.push(this.personToSplit.lastTranSerialNumber);
          let sortedAllLastTransIds = allTransIdsFromHistRecords.sort();
          let temp5 = temp4.data.data;
          let ids = temp5.map(a => a.tranSerialNumber);
          let aliasIdTransSerialNumber = ids.map(Number);
          let inValidIds = sortedAllLastTransIds.filter(item => aliasIdTransSerialNumber.includes(item));
          let validAliasIds = aliasIdTransSerialNumber.filter(item => !inValidIds.includes(item));
          this.personToSplitAliasIdInfo = temp5.filter(item => validAliasIds.includes(item.tranSerialNumber));
          if (this.personToSplitHistInfo.length === 0) {
            this.cannotSplit = true;
          }
          const temp6 = await axios.get(`personid/transactions/details?pidSubmissionId=${this.personToSplit.lastTranSerialNumber}&getDetails=true`);
          if (temp6.data && temp6.data.data && temp6.data.data.length !== 0) {
            this.personToSplitMatchingInfo = temp6.data.data[0];
          }
          const temp7 = await axios.get(`/personid/transactions/${this.personToSplit.lastTranSerialNumber}/transbatch`);
          if (temp7 && temp7.status === 200 && temp7.data && temp7.data.length !== 0) {
            this.personToSplitTransactionInfo = temp7.data;
          }
          const histLastTrans = this.personToSplitHistInfo.map(a => a.lastTranSerialNumber);
          histLastTrans.forEach(async element => {
            let result = await axios.get(`personid/transactions/details?pidSubmissionId=${element}&getDetails=true`);
            if (result.data && result.data.data && result.data.data.length !== 0) {
              this.allHistMatchingInfo.push(result.data.data[0]);
            }
            let result2 = await axios.get(`/personid/transactions/${element}/transbatch`);
            if (result2 && result2.status === 200 && result2.data && result2.data.length !== 0) {
              this.allHistTransactionInfo.push(result2.data);
            }
          });
        }
      } catch (error) {
        if (error.response.status === 403) {
          this.personTypeMisMatched = true;
        }
        if (error.response.status === 400) {
          this.dataAccessPermission = true;
        }
        this.dataAccessErrorMessage = error.response.data.message;
        this.showError(error.response.data.message);
      } finally {
        if (this.personToSplit && this.personToSplit.personType) {
          if (!this.hasDistrictAccess()) {
            this.dataAccessPermission = true;
            const unauthorizedDistricts = this.setOfPersonDistricts.filter(district => !this.districts.includes(district));
            this.dataAccessErrorMessage = `User is not authorized to submit records to the specified district: District=${unauthorizedDistricts}`;
          } else if (!this.hasSchoolAccess()) {
            this.dataAccessPermission = true;
            const unauthorizedSchools = this.setOfPersonSchools.filter(school => !this.schools.includes(school));
            this.dataAccessErrorMessage = `User is not authorized to submit records to the specified school: School=${unauthorizedSchools}`;
          } else if (!this.hasPersonTypeAccess()) {
            this.differentPersonType = true;
            this.diffPersonType = this.setOfPersonPersonTypes.filter(personType =>
              !this.personTypes.includes(personType)
            );
          }
        }
        this.loading = false;
      }
    },
    hasDistrictAccess() {
      return this.districts.length === 0 || this.setOfPersonDistricts.every(district => this.districts.includes(district));
    },
    hasSchoolAccess() {
      return this.schools.length === 0 || this.setOfPersonSchools.every(school => this.schools.includes(school));
    },
    hasPersonTypeAccess() {
      return this.personTypes.length === 0 || this.setOfPersonPersonTypes.every(personType => this.personTypes.includes(personType));
    },
    setLoadingError() {
      this.loadingError = true;
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    storeData(requestData) {
      this.requestData = requestData;
      this.page = 'Review';
      this.toggleComponent();
    },
    cancelReviewData() {
      this.page = 'Details';
      this.toggleComponent();
    },
    storeNewIdToCreate(data) {
      this.newIdToCreate = data;
    },
    toggleComponent() {
      this.showSharedIdGroupDetails = !this.showSharedIdGroupDetails;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
    padding: 0.5rem !important
</style>
